import './swatch-row--split';



// WEBPACK FOOTER //
// ./client/src/core/components/swatch-row/index.js